import React from "react";
import { Modal } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import Lottie from "lottie-react";
import animationData from "../../../assets/img/animated-icons/check-primary-light.json";
import { GetAllClaimsList } from "../config/cliamApi";
import { useDispatch } from "react-redux";

const SuccessSubmitModal = ({
  modal,
  setModal,
  title,
  description,
  setSelectedAction,
}) => {
  const dispatch = useDispatch();
  return (
    <Modal
      show={modal}
      onHide={async () => {
        setModal(false);

        setSelectedAction("select Action");
      }}
      centered
      dialogClassName="wizard-modal"
    >
      <Modal.Body>
        <FalconCloseButton
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
          onClick={async () => {
            setModal(!modal);

            setSelectedAction("select Action");
          }}
        />
        <Flex justifyContent="center" alignItems="center">
          <Lottie
            animationData={animationData}
            loop={true}
            style={{ width: "100px" }}
          />
          <div className="mb-0 flex-1 d-flex flex-column">
            <h6 className="fs-8">{title}</h6>
            <h6 className="fs-10">{description}</h6>
          </div>
        </Flex>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessSubmitModal;
